enum ProductInfoActionTypesEnum {
  SAVE_POSTS = 'SAVE_POSTS',
  SET_SELECTED_POST = 'SET_SELECTED_POST',
  SAVE_VASHO_MANUAL = 'SAVE_VASHO_MANUAL',
  SAVE_DEVELOPERS_POSTS = 'SAVE_DEVELOPERS_POSTS',
  SAVE_ISEO_TRAINING_MATERIALS = 'SAVE_ISEO_TRAINING_MATERIALS',
}

export default ProductInfoActionTypesEnum;
